"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotificationsController = void 0;
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const NotificationsController = (param)=>{
    let { notificationMessages } = param;
    (0, _logger2.logDebug)("Rendering NotificationsController ...", '\n\tnotificationMessages: ', notificationMessages);
    // If there are no records we should not render anything
    if (notificationMessages === undefined || notificationMessages.length === 0) {
        (0, _logger2.logDebug)('No notification messages to display. Exiting ...');
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.StrictMode, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "".concat(_constants.LIBRARY_NAME, "-boundary"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
                        team: _testidGenerator.Team.Checkout,
                        project: _constants.LIBRARY_NAME,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.NotificationHolder, {
                            notificationMessages: notificationMessages
                        })
                    })
                })
            })
        })
    });
};
exports.NotificationsController = NotificationsController;
